/*import plugins*/
import ENDPOINTS from "@/plugins/axios/endpoints";

let pending = null;
let pendingMode = null;

const ItemGroups = {
  namespaced: true,

  state: {
    itemGroups: []
  },

  getters: {
    itemGroups: state => state.itemGroups
  },

  mutations: {
    setItemGroups: (state, val) => {
      state.itemGroups = val;
    }
  },

  actions: {
    async loadItemGroups({ commit, rootGetters }) {
      const isDelivery = rootGetters["Config/isDelivery"] ? 1 : 0;

      //share the pending request instead of firing the same call twice
      if (pending && pendingMode === isDelivery) {
        return pending;
      }

      pendingMode = isDelivery;
      pending = axios
        .get(ENDPOINTS.DELIVERY.ITEMGROUPS.GET_ALL, { params: { isDelivery } })
        .then(response => {
          if (
            response.status >= 200 &&
            response.status < 300 &&
            response.data !== "" &&
            response.data !== null &&
            typeof response.data !== "undefined"
          ) {
            commit("setItemGroups", response.data.data);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          pending = null;
          pendingMode = null;
        });

      return pending;
    }
  }
};

export default ItemGroups;
